module.exports = __webpack_public_path__ + "static/media/blueDeposit.e74e33a0.svg";